var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66699C11.3807 6.66699 12.5 5.5477 12.5 4.16699C12.5 2.78628 11.3807 1.66699 10 1.66699C8.61929 1.66699 7.5 2.78628 7.5 4.16699C7.5 5.5477 8.61929 6.66699 10 6.66699Z",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41668 6.66699C5.05606 6.67073 4.70638 6.79135 4.42014 7.01072C4.1339 7.2301 3.92654 7.53641 3.82918 7.88366L1.75002 15.417C1.68702 15.6608 1.68009 15.9157 1.72975 16.1626C1.77941 16.4095 1.88438 16.6419 2.03675 16.8424C2.18913 17.0429 2.38495 17.2063 2.60952 17.3202C2.83409 17.4342 3.08157 17.4957 3.33335 17.5003H16.6667C16.9239 17.5002 17.1776 17.4406 17.408 17.3261C17.6383 17.2116 17.839 17.0453 17.9944 16.8403C18.1497 16.6353 18.2556 16.3972 18.3035 16.1444C18.3515 15.8917 18.3403 15.6313 18.2708 15.3837L16.1667 7.91699C16.0749 7.5615 15.8683 7.24626 15.579 7.02023C15.2897 6.7942 14.9338 6.67002 14.5667 6.66699H5.41668Z",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weight-icon.2e4fc4c64de33870ac2417aa0bfb93df.svg";
export { ForwardRef as ReactComponent };